/*
 * @Description: echarts 基础配置文件
 * @Date: 2020-07-18 12:55:08
 */
import echarts from 'echarts';
const pieColor = ['#36CBF2', '#F6AF36', '#F06B8E', '#367BF2', '#B86CFC'];

export default {
  // 射线
  line: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: 'rgb(190, 226, 250)',
          type: 'dashed'
        }
      }
    },
    grid: {
      containLabel: true,
      left: '5%',
      bottom: 10
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisTick: {
        show: false
      },
      nameTextStyle: {
        color: '#E0E0E0',
        padding: [30, 0, 0, 10]
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#666666',
          fontSize: 12,
          lineHeight: 30
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      }
    },
    yAxis: {
      minInterval: 1,
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#F0F3FF'],
          width: 1,
          type: 'solid'
        }
      },
      label: {
        show: true,
        position: 'top',
        padding: 10,
        textStyle: {
          color: '#606266',
          fontSize: 14
        }
      },
      nameTextStyle: {
        color: '#152E70',
        padding: [0, 0, 15, 0]
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#E0E0E0',
          fontSize: 14
        }
      },
      axisLine: {
        lineStyle: {
          width: 0
        }
      }
    },
    series: [
      {
        symbol: 'circle',
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line',
        z: 1,
        lineStyle: {
          width: 0
        },
        itemStyle: {
          color: '#72AEFF',
          borderColor: '#72AEFF',
          borderWidth: 4
        },
        label: {
          show: true,
          fontSize: 14,
          distance: 10,
          position: 'top',
          color: '#606266',
          formatter(v) {
            return v.value || '';
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(207, 233, 251, 1)'
            },
            {
              offset: 1,
              color: 'rgba(207, 233, 251, 0)'
            }
          ])
        }
      },
      {
        type: 'bar',
        barWidth: 1,
        z: 2
      }
    ]
  },
  line1: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: 'rgb(190, 226, 250)',
          type: 'dashed'
        }
      }
    },
    grid: {
      containLabel: true
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisTick: {
        show: false
      },
      nameTextStyle: {
        color: '#E0E0E0',
        padding: [30, 0, 0, 10]
      },
      axisLabel: {
        show: true,
        interval: 0,
        textStyle: {
          color: '#666666',
          fontSize: 12,
          lineHeight: 30
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      }
    },
    yAxis: {
      minInterval: 1,
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#F0F3FF'],
          width: 1,
          type: 'solid'
        }
      },
      label: {
        show: true,
        position: 'top',
        padding: 10,
        textStyle: {
          color: '#606266',
          fontSize: 14
        }
      },
      nameTextStyle: {
        color: '#152E70'
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#E0E0E0',
          fontSize: 14
        }
      },
      axisLine: {
        lineStyle: {
          width: 0
        }
      }
    },
    series: [
      {
        symbol: 'circle',
        type: 'line',
        z: 1,
        silent: true,
        lineStyle: {
          width: 2,
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 0,
              color: '#47D2FF'
            },
            {
              offset: 1,
              color: '#AAA8FF'
            }
          ]),
          shadowBlur: 4,
          shadowColor: '#E1E0F3',
          shadowOffsetX: 13,
          shadowOffsetY: 10
        },
        itemStyle: {
          color: '#649BFF',
          borderColor: '#649BFF',
          borderWidth: 4,
          shadowBlur: 4,
          shadowColor: '#E1E0F3',
          shadowOffsetX: 13,
          shadowOffsetY: 10
        },
        label: {
          show: false
        }
      }
    ]
  },
  line2: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: 'rgb(190, 226, 250)',
          type: 'dashed'
        }
      }
    },
    grid: {
      containLabel: true
    },
    xAxis: {
      boundaryGap: [0, 0.01],
      minInterval: 1,
      axisTick: {
        show: false
      },
      nameTextStyle: {
        color: '#E0E0E0',
        padding: [30, 0, 0, 10]
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#666666',
          fontSize: 12,
          lineHeight: 30
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      }
    },
    yAxis: {
      minInterval: 1,
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#F0F3FF'],
          width: 1,
          type: 'solid'
        }
      },
      label: {
        show: true,
        position: 'top',
        padding: 10,
        textStyle: {
          color: '#606266',
          fontSize: 14
        }
      },
      nameTextStyle: {
        color: '#E0E0E0'
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#E0E0E0',
          fontSize: 14
        }
      },
      axisLine: {
        lineStyle: {
          width: 0
        }
      }
    },
    series: [
      {
        symbol: 'circle',
        type: 'line',
        z: 1,
        silent: true,
        smooth: true,
        smoothMonotone: 'x',
        lineStyle: {
          width: 4,
          color: '#6764FF',
          shadowBlur: 4,
          shadowColor: '#E1E0F3',
          shadowOffsetX: 13,
          shadowOffsetY: 10
        },
        areaStyle: {
          color: '#F8FAFF'
        },
        itemStyle: {
          color: '#6764FF',
          borderWidth: 1
        },
        label: {
          show: true,
          position: 'top',
          textStyle: {
            color: '#666666',
            fontSize: 14
          }
        }
      }
    ]
  },
  // 横向柱图
  bar: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(150,150,150,0.1)'
        }
      }
    },
    grid: {
      containLabel: true,
      left: '5%',
      bottom: 10
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      minInterval: 1,
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#F0F3FF'],
          width: 1,
          type: 'solid'
        }
      },
      nameTextStyle: {
        color: '#E0E0E0',
        padding: [30, 0, 0, 10]
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#E0E0E0',
          fontSize: 14
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      }
    },
    yAxis: {
      type: 'category',
      minInterval: 1,
      axisTick: {
        show: false
      },
      label: {
        show: true,
        position: 'top',
        padding: 10,
        textStyle: {
          color: '#606266',
          fontSize: 14
        }
      },
      nameTextStyle: {
        color: '#666'
      },
      axisLabel: {
        show: true,
        // rotate: -90,
        textStyle: {
          color: '#666',
          fontSize: 12
        }
      },
      axisLine: {
        lineStyle: {
          color: '#726FFF',
          width: 3
        }
      }
    },
    series: [
      {
        type: 'bar',
        barWidth: '20px',
        label: {
          show: true,
          fontSize: 14,
          distance: 10,
          position: 'top',
          color: '#606266',
          formatter(v) {
            return v.value || '';
          }
        },
        data: [18203, 23489, 29034, 104970, 131744, 630230]
      }
    ]
  },
  // 纵向柱图
  bar2: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(150,150,150,0.1)'
        }
      }
    },
    grid: {
      containLabel: true,
      left: '5%',
      bottom: 10
    },
    xAxis: {
      type: 'category',
      minInterval: 1,
      axisTick: {
        show: false
      },
      nameTextStyle: {
        color: '#666'
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#666',
          fontSize: 12
        }
      },
      axisLine: {
        lineStyle: {
          color: '#726FFF',
          width: 3
        }
      }
    },
    yAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      minInterval: 1,
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#F0F3FF'],
          width: 1,
          type: 'solid'
        }
      },
      nameTextStyle: {
        color: '#E0E0E0',
        padding: [0, 20, 10, 0]
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#E0E0E0',
          fontSize: 14
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      }
    },
    series: [
      {
        type: 'bar',
        barWidth: '20px',
        label: {
          show: true,
          fontSize: 14,
          distance: 10,
          position: 'top',
          color: '#606266',
          formatter(v) {
            return v.value || '';
          }
        },
        data: [18203, 23489, 29034, 104970, 131744, 630230]
      }
    ]
  },
  // 圆形柱图
  bar3: {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(150,150,150,0.1)'
        }
      }
    },
    grid: {
      containLabel: true,
      left: '5%',
      bottom: 10
    },
    xAxis: {
      minInterval: 0,
      axisTick: {
        show: false
      },
      nameTextStyle: {
        color: '#666'
      },
      axisLabel: {
        show: true,
        interval: 0,
        padding: [15, 0, 0, 0],
        textStyle: {
          color: '#666',
          fontSize: 12
        }
      },
      axisLine: {
        lineStyle: {
          color: '#F0F3FF',
          width: 1
        }
      }
    },
    yAxis: {
      boundaryGap: [0, 0.01],
      minInterval: 1,
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['#F0F3FF'],
          width: 1,
          type: 'solid'
        }
      },
      nameTextStyle: {
        color: '#E0E0E0',
        padding: [0, 20, 10, 0]
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: '#E0E0E0',
          fontSize: 14
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0
        }
      }
    },
    series: [
      {
        type: 'bar',
        barWidth: '20px',
        label: {
          show: true,
          fontSize: 14,
          distance: 10,
          position: 'top',
          color: '#606266',
          formatter(v) {
            return v.value || '';
          }
        },
        data: [18203, 23489, 29034, 104970, 131744, 630230]
      }
    ]
  },
  // 圆
  pie: {
    tooltip: {
      trigger: 'item',
      formatter: '{b}' // '{a} <br/>{b}: {c} ({d}%)'
    },
    color: pieColor,
    series: [
      {
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: true,
        // center: ['40%', '40%'],
        label: {
          show: true,
          position: 'outside'
        },
        labelLine: {
          normal: {
            length: 10,
            length2: 20,
            lineStyle: {
              width: 1
            }
          }
        },
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: '30',
        //     fontWeight: 'bold'
        //   }
        // },
        // itemStyle: {
        //   normal: {
        //     color: function(params) {
        //       return colorList[params.dataIndex];
        //     }
        //   }
        // },
        data: []
      }
    ]
  },
  // 地图
  map: {
    // visualMap: {
    //   min: 0,
    //   max: 1000,
    //   showLabel: !0,
    //   pieces: [
    //     {
    //       gt: 0,
    //       lt: 200,
    //       label: '0-200人',
    //       color: '#25B8FF'
    //     },
    //     {
    //       gt: 201,
    //       lt: 400,
    //       label: '201-400人',
    //       color: '#2CDFF9'
    //     },
    //     {
    //       gt: 401,
    //       lt: 600,
    //       label: '401-600人',
    //       color: '#487DFF'
    //     },
    //     {
    //       gt: 601,
    //       lt: 800,
    //       label: '601-800人',
    //       color: '#FFBC4F'
    //     },
    //     {
    //       gt: 801,
    //       label: '801人以上',
    //       color: '#FF3472'
    //     }
    //   ],
    //   show: !0
    // },
    geo: [
      {
        type: 'map',
        map: 'chinaMapOutline',
        label: {
          show: false
        },
        silent: true,
        itemStyle: {
          areaColor: '#FDFDFF',
          borderColor: '#F0F4FD',
          borderWidth: 1
        },
        top: 43
      },
      {
        type: 'map',
        map: 'chinaMapOutline',
        label: {
          show: false
        },
        silent: true,
        itemStyle: {
          areaColor: 'rgba(0,0,0,0)',
          borderColor: '#80A7FF',
          borderWidth: 1
        },
        top: 36
      },
      {
        type: 'map',
        map: 'china',
        itemStyle: {
          areaColor: 'rgba(0,0,0,0)',
          borderColor: '#C9D9FF',
          borderWidth: 0.5
        },
        emphasis: {
          label: {
            show: false
          },
          itemStyle: {
            areaColor: 'rgba(0,0,0,0)'
          }
        },
        top: 36
      }
    ],
    series: []
  },
  // 散点
  scatter: {},
  custom: {},
  radar: {
    tooltip: {
      show: false
    },
    radar: {
      indicator: [
        { text: '指标一' },
        { text: '指标二' },
        { text: '指标三' },
        { text: '指标四' },
        { text: '指标五' }
      ],
      center: ['50%', '50%'],
      radius: '80%',
      startAngle: 90,
      splitNumber: 4,
      shape: 'circle',
      name: {
        formatter: '{value}',
        textStyle: {
          color: '#666'
        }
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(250,250,250,0)']
        }
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.8)'
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: 'white'
        }
      },
      axisLine: {
        lineStyle: {
          width: 2,
          color: '#EFF3FF'
        }
      },
      splitLine: {
        lineStyle: {
          color: '#EFF3FF'
        }
      }
    },
    series: [
      {
        type: 'radar',
        radarIndex: 0,
        lineStyle: {
          color: '#A5A4FF'
        },
        areaStyle: {
          color: 'rgba(138, 168, 255, .32)'
        },
        data: []
      }
    ]
  }
};
